import listjs from 'list.js';

class EventsList {
	static TYPE_ALL = 'all';
	static TYPE_ONLINE = 'online';
	static TYPE_PRESENCE = 'presence';

	initialized = false;
	showEventType = EventsList.TYPE_ALL;

	constructor(element) {
		this.root = element;
		this.listContainer = this.root.querySelector('.js-eventTilesListContainer');

		this.onButtonClick = ::this.onButtonClick;
		this.updateFilter = ::this.updateFilter;
		this.filterItems = ::this.filterItems;

		const options = {
			valueNames: [{ data: ['online-event'] }],
		};
		this.list = new listjs(this.listContainer, options);

		this.initButtons();
	}

	initButtons() {
		this.buttons = Array.from(this.root.querySelectorAll('.js-reventFilterButtons'));
		this.buttons.forEach(button => button.addEventListener('click', this.onButtonClick));
	}

	onButtonClick(e) {
		this.buttons.forEach(button => button.classList.remove('is-active'));
		this.showEventType = e.currentTarget.dataset.show;
		this.updateFilter();
		e.currentTarget.classList.add('is-active');
	}

	updateFilter() {
		this.list.filter(this.filterItems);
	}

	filterItems(item) {
		if (
			this.showEventType === EventsList.TYPE_ALL ||
			(Number(item.values()['online-event']) === 1 &&
				this.showEventType === EventsList.TYPE_ONLINE) ||
			(Number(item.values()['online-event']) !== 1 &&
				this.showEventType === EventsList.TYPE_PRESENCE)
		) {
			return true;
		} else {
			return false;
		}
	}
}

Array.from(document.querySelectorAll('.js-eventsList')).forEach(el => new EventsList(el));
